import { createContext, useContext, type ReactNode } from 'react';

export interface DashboardActionMeta {
  id: string;
  label: string;
  kind: string;
}

export interface DashboardRuntimeConfig {
  /** Base URL the dashboard polls + posts actions against (no trailing slash). */
  apiUrl: string;
  /** Per-manifest action metadata, keyed by action id. */
  actionMeta: Record<string, DashboardActionMeta>;
}

const DashboardRuntimeContext = createContext<DashboardRuntimeConfig | null>(null);

export function DashboardRuntimeProvider({
  apiUrl,
  actionMeta,
  children,
}: DashboardRuntimeConfig & { children: ReactNode }) {
  return (
    <DashboardRuntimeContext.Provider value={{ apiUrl, actionMeta }}>
      {children}
    </DashboardRuntimeContext.Provider>
  );
}

export function useDashboardRuntime(): DashboardRuntimeConfig {
  const ctx = useContext(DashboardRuntimeContext);
  if (!ctx) {
    throw new Error('useDashboardRuntime: missing <DashboardRuntimeProvider>');
  }
  return ctx;
}
